// src/utils/geocode.js
const NOMINATIM = "https://nominatim.openstreetmap.org";

// TIP: puedes pasar tu email para buen uso ("email=...").
// En browser no puedes setear "User-Agent" personalizado.
const qsEmail = (email) => (email ? `&email=${encodeURIComponent(email)}` : "");

export async function forwardGeocode(query, { email } = {}) {
    if (!query) return [];
    const url = `${NOMINATIM}/search?format=json&addressdetails=1&limit=5&q=${encodeURIComponent(query)}${qsEmail(email)}`;
    const res = await fetch(url, { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("Fallo geocodificación");
    const data = await res.json();
    return Array.isArray(data) ? data : [];
}

export async function reverseGeocode(lat, lon, { email } = {}) {
    const url = `${NOMINATIM}/reverse?format=json&addressdetails=1&lat=${lat}&lon=${lon}${qsEmail(email)}`;
    const res = await fetch(url, { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("Fallo reverse geocoding");
    const data = await res.json();
    return data; // { display_name, address, ... }
}
